import React from "react";
import "./Playlist.css";
import organImage from "./fotos/piano.jpg";

const Playlist = () => {
  return (
    <div>
      <div className="playlist-container">
        <img src={organImage} alt="Organ" className="playlist-image" />
        <h1>Programma</h1>
        
        <h2>Carel Anton Fodor (1768-1846)</h2>
        <p>Sonate in F</p>
        <ul>
          <li>Allegro non troppo</li>
          <li>Andante un poco Allegro</li>
          <li>Allegro assai</li>
        </ul>

        <h2>Samuel de Lange jr. (1840-1911)</h2>
        <ul>
          <li>Nocturne in Es</li>
          <li>Nocturne in e/E</li>
        </ul>

        <h2>Gijs Boelen (geb. 1984)</h2>
        <ul>
          <li>Mei</li>
          <li>In het Verre Oosten</li>
          <li>Suspense</li>
          <li>Intermezzo</li>
          <li>Treurmars</li>
          <li>Gondellied</li>
          <li>De Marionet</li>
          <li>Zigeunerdans</li>
        </ul>
      </div>
    </div>
  );
};

export default Playlist;
